<template>
    <main>
        <Header />
        <div class="page-slot" style="min-height: 100vh">
            <slot  />    
        </div>
        <Footer />
        <Cookie />
    </main>
</template>

<script>
import Header from '@/components/layoutComponents/Header.vue'
import Footer from '@/components/layoutComponents/Footer.vue'
import Cookie from '@/components/layoutComponents/Cookie.vue'

export default {
    components:{
        Header,
        Footer,
        Cookie
    }
}
</script>